/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseDictStrUnionStrNoneTypeDataAnyOf } from './genericApiResponseDictStrUnionStrNoneTypeDataAnyOf';

export type GenericApiResponseDictStrUnionStrNoneTypeData = GenericApiResponseDictStrUnionStrNoneTypeDataAnyOf | null;
